import { CloudIcon, DropletIcon, SunIcon, WindIcon, ZapIcon } from '@utils/icons';
import type { WeatherConditionCode } from '@interfaces/IWeatherInsights';

/** Icon per weather condition code. Shared by the conditions header and the
 *  forecast ribbon so the mapping lives in exactly one place. */
export const CONDITION_ICON: Record<WeatherConditionCode, typeof SunIcon> = {
  clear: SunIcon,
  partly_cloudy: CloudIcon,
  cloudy: CloudIcon,
  rain: DropletIcon,
  snow: CloudIcon,
  thunderstorm: ZapIcon,
  fog: CloudIcon,
  wind: WindIcon,
};
